import React, { useCallback, useMemo, useState } from 'react'
import { useRouter } from 'next/router'

import { Button } from 'components/Common'
import AppointmentBookingModal from 'components/Appointments/AppointmentBookingModal'

import useMediaQuery from 'hooks/useMediaQuery'

import { defaultStyles as styles } from './styles'

export const ProviderActions = ({
  onOpenBookingCheck,
  provider,
  isBookingDataLoading,
  bookingData,
  onGetBookingData,
  isBookAppointmentLoading,
  bookAppointmentStatus,
  onBookAppointment,
  onResetBooking
}) => {
  const router = useRouter()
  const { isMobile } = useMediaQuery()
  const [isOpenModal, setIsOpenModal] = useState(false)

  const isCanOpenModal = useMemo(() => {
    return isOpenModal && (!onOpenBookingCheck || onOpenBookingCheck())
  }, [isOpenModal, onOpenBookingCheck])

  const goToProviderProfile = useCallback(() => {
    if (router.pathname.includes('guest')) {
      router.push(`/guest/providers/${provider.id}`)
    } else {
      router.push(`/providers/${provider.id}`)
    }
  }, [router, provider.id])

  const openBookingModal = useCallback(() => {
    setIsOpenModal(true)
  }, [])

  return (
    <div
      style={{
        ...styles.container,
        ...(isMobile && styles.containerBorderTop)
      }}
    >
      {isCanOpenModal && (
        <AppointmentBookingModal
          provider={provider}
          isBookingDataLoading={isBookingDataLoading}
          bookingData={bookingData}
          onGetBookingData={onGetBookingData}
          isBookAppointmentLoading={isBookAppointmentLoading}
          bookAppointmentStatus={bookAppointmentStatus}
          onBookAppointment={onBookAppointment}
          onResetBooking={onResetBooking}
          onOpenBookingCheck={onOpenBookingCheck}
          isOpenModal={isOpenModal}
          setIsOpenModal={setIsOpenModal}
        />
      )}
      <Button onClick={openBookingModal} style={styles.buttonBook(isMobile)}>
        Book online
      </Button>
      <Button
        href={`tel:${provider.phone}`}
        style={styles.buttonCall(isMobile)}
      >
        CALL
      </Button>
      <div style={styles.link} onClick={goToProviderProfile}>
        View Profile
      </div>
    </div>
  )
}
